export default function amount(value, currency) {
  if (Intl === undefined) {
    return (value / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  }

  let locale = 'sv-SE';
  if (navigator.languages !== undefined) {
    [locale] = navigator.languages;
  }

  return new Intl.NumberFormat(locale, { style: 'currency', currency, currencyDisplay: 'symbol' }).format(value / 100);
}
